var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"py-md-3 text-center",attrs:{"min-height":"3em","color":_vm.colorBkgd}},[_c('span',{staticClass:"fs-1_2 primary--text"},[_c('b',[_vm._v(_vm._s(_vm.title)+" ")]),_vm._v(" "+_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }